"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var utils_1 = require("./utils");
var prosemirror_state_1 = require("prosemirror-state");
var const_1 = require("./const");
var menu_button_1 = require("./component/menu-button");
var prose_util_1 = require("@syl-editor/core-utilities/dist/lib/libs/prose-util");
var TableItem = /** @class */ (function (_super) {
    __extends(TableItem, _super);
    function TableItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = const_1.NODE_NAME.TABLE;
        _this.content = 'table_row+';
        _this.tableRole = 'table';
        _this.isolating = true;
        _this.notLastLine = true;
        _this.group = 'block';
        _this.parseDOM = [{ tag: 'table' }];
        _this.toDOM = function () {
            return ['table', ['tbody', 0]];
        };
        return _this;
    }
    return TableItem;
}(core_utilities_1.Block));
exports.TableItem = TableItem;
var TableItemController = /** @class */ (function (_super) {
    __extends(TableItemController, _super);
    function TableItemController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.name = const_1.NODE_NAME.TABLE;
        _this.menuBtn = null; // 菜单
        _this.$menu = null; // 挂载菜单的DOM
        _this.insertTable = function (_a) {
            var row = _a.row, column = _a.column;
            var node = utils_1.createTableNode(row, column, {
                cellWidth: _this.props.defaultCellWidth,
                useTableHeader: _this.props.useTableHeader
            });
            var index = _this.editor.getSelection().index;
            var $from = _this.editor.view.state.selection.$from;
            node && _this.editor.insert(node);
            var indexOffset = index + 3;
            if ($from && $from.node().childCount) {
                indexOffset = index + 5;
            }
            _this.editor.setSelection({
                index: indexOffset,
                length: 0
            });
        };
        _this.keymap = {
            Tab: function (editor, state, dispatch) { return utils_1.goToCell(state, dispatch); },
            'Shift-Tab': function (editor, state, dispatch) {
                return utils_1.goToCell(state, dispatch, -1);
            },
            Backspace: function (editor, state, dispatch, view) {
                var _a = state.selection, $anchor = _a.$anchor, from = _a.from, to = _a.to;
                var tr = state.tr;
                if (utils_1.judgeSelectAllTable(view)) {
                    var $pos = state.selection.$anchor;
                    var node = $pos.node(1);
                    if (node.type.spec.tableRole !== 'table')
                        return false;
                    tr.setSelection(core_utilities_1.TextSelection.create(tr.doc, $pos.before(1), $pos.after(1))).deleteSelection();
                    dispatch(tr);
                    return true;
                }
                if (from !== to)
                    return false;
                var $cut = prose_util_1.findCutBefore($anchor);
                if (!$cut)
                    return false;
                var before = $cut.nodeBefore;
                // 当前为空，前面是 table 的情况
                if (!before || before.type.spec.tableRole !== 'table' || $cut.pos !== from - 1)
                    return false;
                tr.setSelection(prosemirror_state_1.NodeSelection.create(state.doc, $cut.pos - before.nodeSize));
                dispatch(tr);
                return true;
            }
        };
        _this.toolbar = {
            name: const_1.NODE_NAME.TABLE,
            tooltip: const_1.NODE_NAME.TABLE,
            getRef: function (dom) {
                if (_this.$menu && _this.$menu !== dom && _this.menuBtn)
                    _this.menuBtn.unMount();
                _this.$menu = dom;
                _this.menuBtn = new menu_button_1.TableButton(_this.editor, dom, _this.insertTable, _this.props || {});
            },
            handler: function (editor) { }
        };
        _this.disable = function (editor) { return Boolean(utils_1.closestTable(editor.view.state.selection.$from)); };
        // @ts-ignore
        if (_this.props.trigger === 'hover')
            _this.toolbar.tooltip = false;
        return _this;
    }
    TableItemController.prototype.editorWillUnmount = function () {
        this.menuBtn && this.menuBtn.unMount();
    };
    return TableItemController;
}(core_utilities_1.SylController));
exports.TableItemController = TableItemController;
var TableItemPlugin = /** @class */ (function (_super) {
    __extends(TableItemPlugin, _super);
    function TableItemPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Controller = TableItemController;
        _this.Schema = TableItem;
        return _this;
    }
    return TableItemPlugin;
}(core_utilities_1.SylPlugin));
exports.TableItemPlugin = TableItemPlugin;
//# sourceMappingURL=table-item.js.map